import styled, { css } from "styled-components"
import { getColorFromVariant } from "../typography/utils"
import Button from "../button"

const summaryFontSize = (size) => {
  switch (size) {
    case "small":
      return "1.25rem"
    case "medium":
      return "1.75rem"
    case "large":
      return "2rem"
    default:
      return "1.5rem"
  }
}

export const Container = styled.div`
  user-select: text;

  &:empty {
    display: none;
  }

  > :first-child {
    margin-top: 0;
  }

  > :last-child {
    margin-bottom: 0;
  }

  ${({ simpleForm }) =>
    simpleForm &&
    css`
      border: 1px solid #e6e6e6;
      padding: 24px;
      border-radius: 8px;
      color: #19434a;
    `};
`

export const Img = styled.img`
  max-width: 100%;
`

export const Table = styled.table`
  color: ${({ variant }) => getColorFromVariant(variant)};
  font-family: ${({ theme }) => theme.fonts.body.family}, sans-serif;
  font-weight: ${({ theme }) => theme.fonts.body.weight};
  border: 1px solid ${({ variant }) => getColorFromVariant(variant)};

  td,
  th {
    border: 1px solid ${({ variant }) => getColorFromVariant(variant)};
    padding: 0.25rem 0.5rem;
  }

  width: 100%;
  border-collapse: collapse;
`

export const Details = styled.details`
  border: 1px solid #e6e6e6;
  padding: 24px;
  border-radius: 8px;
  margin-bottom: 1rem;

  summary {
    color: ${({ variant }) => getColorFromVariant(variant)};
    font-size: ${({ size }) => summaryFontSize(size)};
    font-family: ${({ theme }) => theme.fonts.headings.family}, sans-serif;
    font-weight: ${({ theme }) => theme.fonts.headings.weight};
    letter-spacing: -1px;
    line-height: 1.2;
    cursor: pointer;
  }

  p > a.cta {
    margin-top: 0;
  }

  > :last-child {
    margin-bottom: 0;
  }
`

export const Li = styled.li`
  color: ${({ variant }) => getColorFromVariant(variant)};
  font-family: ${({ theme }) => theme.fonts.body.family}, sans-serif;
  font-weight: ${({ theme }) => theme.fonts.body.weight};
  margin-bottom: 0.5rem;

  > :last-child {
    margin-bottom: 0;
  }

  ${({ variant }) =>
    variant === "profile" &&
    css`
      margin-left: -20px;
      color: #666666;
      line-height: 1.55em;
    `}
`

export const A = styled.a`
  color: ${({ variant }) => getColorFromVariant(variant)};
  font-family: ${({ theme }) => theme.fonts.body.family}, sans-serif;
  font-weight: ${({ theme }) => theme.fonts.body.weight};
`

export const ButtonA = styled(Button)`
  display: inline-block;
  margin-right: 1rem;
`
